import type { IProtoForm } from './IProtoForm';

/**
 * Поле, що залишило ключовий рядок чи місце під назвою, стає в стандартну групу (прототип v4 effGroups: ключ стандартних груп, не розміщений
 * і не прихований, — у групу з тією самою назвою, інакше нова група наприкінці; «Нотатки» — на весь рядок). Чиста функція.
 */
export function placeInGroup(form: IProtoForm, key: string, title: 'Details' | 'Notes'): IProtoForm {
  if (form.hidden.includes(key) || form.groups.some((g) => g.keys.includes(key))) return form;
  const at = form.groups.findIndex((g) => g.title.en === title);
  if (at >= 0) return { ...form, groups: form.groups.map((g, i) => (i === at ? { ...g, keys: [...g.keys, key] } : g)) };
  const id = form.groups.some((g) => g.id === title.toLowerCase()) ? `auto-${title.toLowerCase()}` : title.toLowerCase();
  return { ...form, groups: [...form.groups, { id, title: { en: title }, full: title === 'Notes', keys: [key] }] };
}

/** Поле, що повернулося в ключовий рядок чи під назву, зникає з груп. Чиста функція. */
export function removeFromGroups(form: IProtoForm, key: string): IProtoForm {
  return { ...form, groups: form.groups.map((g) => (g.keys.includes(key) ? { ...g, keys: g.keys.filter((k) => k !== key) } : g)) };
}
